import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://zmrpsywipneizxmzklqk.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InptcnBzeXdpcG5laXp4bXprbHFrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjI1OTk2MjAsImV4cCI6MjA3ODE3NTYyMH0.i-UC2eeCAz_fGq5x0dd4YkBSqBc1ckFejlDp7QJJ9nk'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
})